var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_199_1995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 40,
    fill: "#8861DB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.5386 52.1254C74.0366 52.6272 74.0393 53.4451 74.5426 53.9482L74.9994 54.4049C75.0844 54.4899 75.0844 54.6253 74.9994 54.7089C74.9144 54.7926 74.7803 54.7913 74.6953 54.7089L73.6289 53.6429C73.123 53.137 72.3076 53.1357 71.8056 53.6389C71.3036 54.1421 71.3063 54.9585 71.8096 55.4617L72.8759 56.5278C72.9609 56.6128 72.9609 56.7482 72.8759 56.8318C72.791 56.9155 72.6568 56.9141 72.5718 56.8318L70.8959 55.1564C70.39 54.6505 69.5746 54.6492 69.0726 55.1524C68.5706 55.6555 68.5733 56.472 69.0766 56.9752L70.7525 58.6507C70.8375 58.7356 70.8375 58.871 70.7525 58.9547C70.6675 59.0383 70.5334 59.037 70.4484 58.9547L64.503 53.0109C63.997 52.5051 63.1817 52.5038 62.6797 53.0069C62.1777 53.5101 62.1804 54.3266 62.6837 54.8298L69.8375 61.9817C68.9 61.8356 67.3223 61.7732 66.3529 62.7424C65.4432 63.6518 65.4671 64.2798 65.75 64.5652C66.5189 65.3339 67.1125 64.1191 70.6157 65.7933C74.1189 67.4674 76.3712 67.3306 77.9117 65.8145L80.0338 63.693C80.0444 63.6823 80.0232 63.7036 80.0338 63.693C82.1904 61.5369 82.8093 58.5883 80.6327 56.411C80.6287 56.407 80.6261 56.4043 80.6221 56.4003L76.3539 52.1334C75.8586 51.6249 75.0406 51.6222 74.5386 52.1254Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5662 35.6148C73.1294 31.4368 68.1004 32.9662 64.9982 35.3878C61.896 32.9649 56.8669 31.4355 49.4302 35.6148C48.5524 36.1087 48 37.0434 48 38.0789V59.4748C48 60.3524 48.3971 61.1742 49.0903 61.7119C49.7848 62.2496 50.6626 62.4341 51.5125 62.2217C56.187 61.0468 60.1391 61.0175 63.2838 62.1513C63.5387 61.684 63.8933 61.2021 64.3608 60.7348C64.3887 60.6923 64.4311 60.6498 64.4736 60.6219L62.9717 59.1204C61.4697 58.6955 59.8416 58.4977 58.0993 58.4977C55.8617 58.4977 53.4394 58.823 50.8326 59.4748L50.8193 38.0776C56.0888 35.1183 60.2679 35.0891 63.5826 37.9223V49.8031C64.6025 49.7885 65.6223 50.1709 66.4152 50.9223V37.9236C69.7298 35.0918 73.909 35.1196 79.1638 38.0789L79.1784 50.9369L81.9964 53.7555V38.0789C81.9964 37.0593 81.444 36.1087 80.5662 35.6148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_199_1995",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.434113 0 0 0 0 0.246528 0 0 0 0 0.833333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_1995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_1995",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter2);
export default __webpack_public_path__ + "static/media/counter-2.8fea01a0a4786211e41a6600d5601e87.svg";
export { ForwardRef as ReactComponent };